import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedProjects: [],
  assignedFolders: {},
  assignedFiles: {},
  selectedAssignedProjectId: null,
  selectedAssignedFolderId: null,
  selectedAssignedFileId: null,
  targetLanguageId: null,
  fileStatus: null, // This can be used to track the status of files (e.g., "pending", "completed", etc.)
  totalSentences: 0
};

const devnagriValidatorSlice = createSlice({
  name: "devnagriValidator",
  initialState,
  reducers: {
    addAssignedProjects: (state, action) => {
      state.assignedProjects = action.payload;
    },
    addAssignedFolders: (state, action) => {
      const { projectId, folders } = action.payload;
      state.assignedFolders = {
        ...state.assignedFolders,
        [projectId]: folders,
      };
    },
    addAssignedFiles: (state, action) => {
      const { folderId, files } = action.payload;
      state.assignedFiles = {
        ...state.assignedFiles,
        [folderId]: files,
      };
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setTargetLanguageId: (state, action) => {
      state.targetLanguageId = action.payload;
    },
    resetDevnagriValidatorState: (state) => {
      Object.assign(state, initialState);
    },
    setFileStatus: (state, action) => {
      state.fileStatus = action.payload;
      // This can be used to track the status of files (e.g., "pending", "completed", etc.) 
    },
    setTotalSentences: (state,action)=>{
      state.totalSentences=action.payload;
    }
  },
});

export const {
  addAssignedProjects,
  addAssignedFolders,
  addAssignedFiles,
  setSelectedAssignedProjectId,
  setSelectedAssignedFolderId,
  setSelectedAssignedFileId,
  setTargetLanguageId,
  resetDevnagriValidatorState,
  setFileStatus,
  setTotalSentences
} = devnagriValidatorSlice.actions;

export default devnagriValidatorSlice.reducer;
